import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel } from "@mui/material";
import React, { useState } from "react";

function NCXFormMultiSelect(props) {
    const [localValue, setLocalValue] = useState({})
    const fieldname = props?.field?.properties?.fieldname;

    const handleCheckSelect = (e) => {
        let newLoc = structuredClone(localValue);
        if (newLoc[e.target.value]) {
            newLoc[e.target.value] = false;
        } else {
            newLoc[e.target.value] = true;
        }
        setLocalValue(newLoc);
        props?.handleInputChange(
            fieldname, 
            e.target.value, 
            props?.field
        )
    }

    const sharedBorder = { 
        border: '1px solid #bdbdbd', 
        borderRadius: '4px', 
        margin: '2px', 
        padding: '3px 5px 0 5px', 
        // height: '3em', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'flex-start' 
    }

    return (
        <Box key={props?.field._id} sx={{ marginBottom: "16px" }}>
            <FormControl disabled={props?.field?.properties?.readOnly}>
                <FormLabel>{props?.field?.properties?.label}</FormLabel>
                <FormGroup row>
                    {
                        props?.field?.properties?.options.map(
                            opt => 
                            <div style={sharedBorder}>
                                <FormControlLabel control={<Checkbox value={opt?.value} onChange={handleCheckSelect} checked={localValue[opt?.value]} />} label={opt?.label} />
                            </div>
                        )
                    }
                </FormGroup>
            </FormControl>
        </Box>
    )
}

export default NCXFormMultiSelect;